import { createDialogContextBundle } from "src/components/Dialog";
import { AccountAlreadyClosedDialogProps } from "./types";

export const {
  DialogContext: AccountAlreadyClosedDialogContext,
  useDialogContext: useAccountAlreadyClosedDialogContext,
} = createDialogContextBundle<AccountAlreadyClosedDialogProps>();
